import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";

export default function isShowLikeClientMessage(
    message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
    you?: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel
): boolean {
    return message.isSendByClient || (you && CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(client) && message.operatorLogin != you.login);
};